import React from 'react';
import Layout from '~/components/Layout';
import CompanyBottomNav from '~/components/CompanyBottomNav';
import Seo from '~/components/SEO';
import { Link, graphql } from 'gatsby';
import chevronUpWhite from '~/icons/chevron-up-white.svg';
import useStoryblok from '~/utils/storyblok-service';
import Image from '~/components/Dynamic/Image';

function Manifesto({ data, location, pageContext }) {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story.content;

  const { heroText, heroImages, change, changeImages, explore, mile, mileImage, stamp, values, valuesImage, buttons } = content;

  const scrollToTop = () => {
    window[`scrollTo`]({ top: 0, behavior: `smooth` });
  };

  return (
    <Layout
      headerColor="black"
      className="relative text-white bg-black"
      footerColor="black"
      hideFooterCta
      locale={pageContext.locale}
    >
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />
      <div className="hidden xl:inline-block fixed right-[10%] top-[90%] cursor-pointer" onClick={scrollToTop}>
        <div className="p-4 transition-colors duration-300 bg-transparent border rounded-full cursor-pointer border-blue hover:bg-blue ">
          <img src={chevronUpWhite} alt="social" className="object-contain w-3 h-3 " />
        </div>
      </div>
      <section className="pt-10 my-16 mb-24 text-white bg-black md:my-32">
        <div className="container flex justify-center">
          <div className="max-w-[45rem]">
            <h1 className="mb-4 font-normal font-heading text-32px md:text-52px tracking-[-0.03em] leading-[1.085em] text-center">
              {heroText}
            </h1>
          </div>
        </div>
      </section>

      <section className="my-20 mb-0 md:my-32">
        <div className="container flex justify-center">
          <div className="flex flex-wrap flex-auto max-w-4xl">
            <div className="w-full mb-8">
              <Image blok={heroImages[0]} />
            </div>
            <div className="w-6/12 ">
              <Image blok={heroImages[1]} />
            </div>
            <div className="w-6/12 pl-8 ">
              <Image blok={heroImages[2]} />
            </div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-32">
        <div className="container flex justify-center">
          <div className="flex-auto max-w-36">
            <h2 className="mb-4 font-normal font-heading tracking-[-0.03em] leading-tight text-38px">
              {values[0]?.heading}
            </h2>
            <div className="prose text-white text-16px">{values[0]?.content}</div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-32">
        <div className="container flex justify-center">
          <div className="flex flex-wrap flex-auto max-w-4xl">
            <div className="w-full ">
              <Image blok={valuesImage} />
            </div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-32 ">
        <div className="container flex justify-center">
          <div className="flex-auto max-w-36">
            <h2 className="mb-4 font-normal font-heading tracking-[-0.03em] leading-tight text-38px">
              {explore[0]?.heading}
            </h2>
            <div className="prose text-white text-16px">
              <p>{explore[0]?.content}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-32">
        <div className="container flex justify-center">
          <div className="flex-auto max-w-36">
            <h2 className="mb-4 font-normal font-heading tracking-[-0.03em] leading-tight text-38px">
              {change[0]?.heading}
            </h2>
            <div className="prose text-white text-16px">
              <p>{change[0]?.content}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-32">
        <div className="container flex justify-center">
          <div className="flex flex-wrap flex-auto max-w-4xl ">
            <div className="w-6/12 ">
              <Image blok={changeImages[0]} />
            </div>
            <div className="w-6/12 pl-8 ">
              <Image blok={changeImages[1]} />
            </div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-32 ">
        <div className="container flex justify-center">
          <div className="max-w-36">
            <h2 className="mb-4 font-normal font-heading tracking-[-0.03em] leading-tight text-38px">
              {mile[0]?.heading}
            </h2>
            <div className="prose text-white text-16px">{mile[0]?.content}</div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-32">
        <div className="container flex justify-center">
          <div className="flex flex-wrap flex-auto max-w-4xl">
            <div className="relative flex-auto aspect-w-5 aspect-h-3 ">
              <Image blok={mileImage} className="absolute object-fill w-full h-full" imageClassName="object-fill" />
            </div>
          </div>
        </div>
      </section>

      <CompanyBottomNav dark items={buttons} />
    </Layout>
  );
}

export default Manifesto;

export const query = graphql`
  query ManifestoQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
